import type { InjectionKey } from 'vue'
import { inject } from 'vue'

export interface ChatReactionContext {
  onTriggerEnter: (messageId: string | number, event: MouseEvent) => void
  onTriggerClick: (messageId: string | number, event: MouseEvent) => void
  onTriggerLeave: (messageId: string | number) => void
  onReactionPillClick: (
    messageId: string | number,
    reactionTypeId: string | number,
    isMyReaction?: boolean,
  ) => void
}

export const chatReactionContextKey: InjectionKey<ChatReactionContext> = Symbol('chatReactionContext')

export function useChatReactionContext(): ChatReactionContext | null {
  return inject(chatReactionContextKey, null)
}
